import { Chip } from "@components/controls/Button"
import { MembersOnlyChip } from "@components/controls/MembersOnlyChip"
import { ChipList } from "@components/layout/ChipList"
import { defineBlock, EditableText, usePostTitleEditor } from "eddev/blocks"
import { ReactNode } from "react"

export const meta: BlockMeta = {
  title: "Resource Header",
  inserter: false,
  icon: "admin-tools",
  postMetaBlock: {
    postTypes: ["resource"],
    fieldName: "resourceMeta2",
  },
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("resources/resource-header", (props) => {
  const tags: ReactNode[] = []

  // props.topic?.forEach((topic, i) => tags.push(<Chip key={`topic_${i}`}>{topic?.name}</Chip>))

  return (
    <div className="grid-auto pt-8 pb-6">
      <div className="col-start-4 col-span-6 stack-y-2">
        <EditableText
          as="h1"
          className="type-title-m-medium text-center"
          store={env.admin ? usePostTitleEditor() : [props.resource?.title!, () => {}]}
          placeholder="Enter a title"
        />
        <div className="stack-x-1 justify-center flex-wrap pt-2">
          <ChipList chips={props.resource?.chips} />
        </div>
      </div>
    </div>
  )
})
